import { Box, Typography } from '@mui/material';
import type { MarketLineMeta } from '../constants';

/** The colour key under the chart. Clicking an entry filters to that market. */
export function MarketLegend({
    marketMeta,
    highlightedMarkets,
    onMarketClick,
}: {
    marketMeta: MarketLineMeta[];
    highlightedMarkets?: Set<string> | null;
    onMarketClick?: (conditionId: string) => void;
}) {
    const hasHighlight = !!(highlightedMarkets && highlightedMarkets.size > 0);
    return (
        <Box
            sx={{
                display: 'flex',
                gap: 1.5,
                flexWrap: 'wrap',
                px: 2,
                pb: 1.25,
            }}
        >
            {marketMeta.map(m => (
                <Box
                    key={m.conditionId}
                    onClick={() => onMarketClick?.(m.conditionId)}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5,
                        cursor: 'pointer',
                        opacity:
                            hasHighlight &&
                            !highlightedMarkets!.has(m.conditionId)
                                ? 0.4
                                : 1,
                        transition: 'opacity 0.15s',
                    }}
                >
                    <Box
                        sx={{
                            width: 8,
                            height: 8,
                            borderRadius: '50%',
                            bgcolor: m.color,
                            flexShrink: 0,
                        }}
                    />
                    <Typography
                        sx={{
                            fontSize: '11px',
                            color: 'text.secondary',
                            fontWeight: 500,
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: 180,
                        }}
                    >
                        {m.question}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
}
